import { SiteState, initialState } from '../state/site.state';
import { SiteActions, GET_MANUFACTURING_LOCATIONS_SUCCESS, GET_UNIT_OF_MEASURE_SUCCESS } from '../actions/site.action';


export function SiteReducer(
    state: SiteState = initialState,
    action: SiteActions
): SiteState {
    switch (action.type) {
        case GET_MANUFACTURING_LOCATIONS_SUCCESS: {
            return {
                ...state,
                manufacturingLocations: action.payload
            };
        }

        case GET_UNIT_OF_MEASURE_SUCCESS: {
            return {
                ...state,
                unitOfMeasures: action.payload
            }
        }

        default: return state;
    }
}
